import React, {useState} from 'react';
import {useIntl} from "react-intl";
import WeChatApplicationDetailDialog from "./WeChatApplicationDetailDialog";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {WeChatApplicationDto} from "../../../../modules/wechat/dto/WeChatApplicationDto";
import {WeChatApplicationApi} from "../../../../modules/wechat/api/WeChatApplicationApi";
import {Card, CardHeader, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {MessageUtils} from "../../../../utils/MessageUtils";
import ModifyIconButton from "../../../../components/buttons/ModifyIconButton";
import DeleteIconButton from "../../../../components/buttons/DeleteIconButton";
import {useConfirm} from "material-ui-confirm";
import AddIconButton from "../../../../components/buttons/AddIconButton";
import RefreshIconButton from "../../../../components/buttons/RefreshIconButton";

export type WeChatApplicationListProps = {
    onRefresh: () => void;
    wechatApplicationList: Array<WeChatApplicationDto>;
};

const WeChatApplicationList: React.FC<WeChatApplicationListProps> = (props) => {
    const intl = useIntl();

    const confirm = useConfirm();

    const [openDetailModal, setOpenDetailModal] = useState(false);

    const [currentRow, setCurrentRow] = useState<WeChatApplicationDto>(new WeChatApplicationDto());

    const handleAdd = () => {
        setCurrentRow(new WeChatApplicationDto());
        setOpenDetailModal(true);
    };

    const handleModify = async (record: WeChatApplicationDto) => {
        const responseResult = await WeChatApplicationApi.getWeChatApplicationDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailModal(true);
        }
    };

    const handleDelete = async (record: WeChatApplicationDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(async () => {
                const responseResult = await WeChatApplicationApi.deleteWeChatApplication(record.id);
                if (responseResult.status === HttpStatus.SUCCESS) {
                    MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
                    props.onRefresh();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    return (
        <Card>
            <WeChatApplicationDetailDialog open={openDetailModal}
                                           onOk={() => props.onRefresh()}
                                           onClose={() => setOpenDetailModal(false)}
                                           wechatApplication={currentRow}/>
            <CardHeader title={intl.formatMessage({id: 'WECHAT_APPLICATION'})}
                        action={
                            <div>
                                <AddIconButton onClick={handleAdd}/>
                                <RefreshIconButton onClick={() => props.onRefresh()}/>
                            </div>
                        }/>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{intl.formatMessage({id: 'WECHAT_APPLICATION_NAME'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'WECHAT_APPLICATION_APP_ID'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'WECHAT_APPLICATION_APP_SECRET'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.wechatApplicationList.map((row, index) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.appId}</TableCell>
                            <TableCell>{row.appSecret}</TableCell>
                            <TableCell>
                                <div>
                                    <ModifyIconButton onClick={() => handleModify(row)}/>
                                    <DeleteIconButton onClick={() => handleDelete(row)}/>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </Card>
    );
};

export default WeChatApplicationList;
